// extracted by mini-css-extract-plugin
export default {"wrapper":"ReadMore_wrapper__Bi7+4","container":"ReadMore_container__y8Nqj","title":"ReadMore_title__YWwC9"};